module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba-funabashi-point2-3@2x-cb7744f9362a2774eec9591c9b26aae3.webp";